import WebStorage from"./WebStorage";export default new WebStorage;
//# sourceMappingURL=index.js.map